import {firestore} from '../firebaseIndex'

///////////////////////////////////////////////////////////////////////////////
export const addDpi = async (domainId, contractId, data ) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId).collection('dpicollection')
            .add(data);
        const newdata = {
            ...data,
            id: res.id,
        }
        return newdata
    } catch (e) {
        console.log("addDpi error: ", e)
        return { error: e }
    }
}



///////////////////////////////////////////////////////////////////////////////
export const getDpiById = async (domainId, contractId, dpiId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('dpicollection')
            .doc(dpiId)
            .get()

        const firebaseData = res.data()
        const data = {
            ...firebaseData,
            id : res.id,
        }
        return data;
    } catch (e) {
        console.log("getDpi error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const getDpiList = async (domainId, contractId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('dpicollection')
            .get();

        const dpiList = res.docs.map(doc => {
            const firebaseData = doc.data()
            const data = {
                ...firebaseData,
                id: doc.id,
            }
            return data
        })
        return dpiList;
        
    } catch (e) {
        console.log("getDpiList error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const editDpi = async (domainId, contractId, dpiId, data) => {
    try {
        const dpi =  firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('dpicollection')
            .doc(dpiId);

        const res = await dpi.set(data)
            .then( () => {
                console.log("editDpi - edit successfully")
                return data
            }).catch( error => {
                console.log("editDpi - edit error: ", error)
                return {error: error}
            });

        return res
    }  catch (e) {
        console.log("editDpi error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const deleteDpi = async (domainId, contractId, dpiId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('dpicollection')
            .doc(dpiId).delete();
        return res
    }  catch (e) {
        console.log("deleteDpi error: ", e)
        return { error: e }
    }
}


